<article class="content-block-fullwidth row text-center">
  <main class="container content-block-fullwidth__inner section-inset-y px-5 px-md-0">
    <h1 class="h2 pb-4">{{ block.title }}</h1>
    <p class="type-body-sm" [innerHTML]="block?.text"></p>
    <footer *ngIf="block?.button?.routerLink || block?.button?.url">
      <a class="button button--light mt-4" [routerLink]="block.button.routerLink" *ngIf="block.button.routerLink">
        {{ block.button?.text }}
      </a>
      <a class="button button--light mt-4" [href]="block.button.url" *ngIf="!block.button.routerLink">{{ block.button?.text }}</a>
    </footer>
  </main>
  <figure>
    <img src="/assets/gfx/mep-circles.svg" />
  </figure>
</article>
